import { User } from './user';
import { Service } from './service';
import { Communique } from './communique';

export enum RequestStatus {
  PENDING_REVIEW = "pending_review",       // بانتظار مراجعة المشرف
  PENDING_COMMITTEE = "pending_committee", // تمت إحالته للجنة، بانتظار القرار
  APPROVED = "approved",                   // تمت الموافقة عليه من اللجنة
  REJECTED = "rejected",                   // تم رفضه من اللجنة
  COMPLETED = "completed",                 // تم إنجاز الخدمة بعد الموافقة (اختياري)
}

  export enum PaymentStatus {
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed"
}
/*export type PaymentStatus = 'pending' | 'paid' | 'failed';*/
// (1) !! إضافة الواجهة الجديدة هنا !!
// هذه الواجهة تمثل البيانات التي نرسلها إلى الخادم عند إنشاء طلب جديد
export interface CreateServiceRequestData {
  service_id: number;
  fee: number;
  note_text?: string;
  documents?: { [key: string]: any }; // حقل اختياري للمستندات
}
// الواجهة الرئيسية لنوع طلب الخدمة
export interface ServiceRequest {
  id: number;
  user_id: number;
  service_id: number;
  
  documents: { [key: string]: any } | null;
  
  status: RequestStatus;
  fee: number;
  payment_status: PaymentStatus;
  created_at: string;

  // --- العلاقات (Relations) ---
  user?: User;
  service?: Service;

  // (2) !! إضافة الحقول الجديدة هنا !!
  communique_id: number | null;
  rejection_reason: string | null;
  
  communique?: Communique;
}
